import { render } from "./SmartFormItem.vue?vue&type=template&id=5038a5d3&ts=true"
import script from "./SmartFormItem.vue?vue&type=script&lang=ts"
export * from "./SmartFormItem.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__